import { tv } from 'tailwind-variants';

export default tv({
    slots: {
        base: 'relative box-border inline-flex items-center rounded-md outline-hidden transition-all duration-300 focus:outline-hidden font-medium cursor-pointer',
        label: 'flex items-center whitespace-nowrap transition-opacity duration-500 opacity-100',
        icon: 'inline-block overflow-visible text-current relative',
        spinner: 'absolute inset-0 flex items-center justify-center',
        spinnerIcon: 'animate-spin text-current',
    },
    variants: {
        color: {
            primary: '',
            danger: '',
            warning: '',
            success: '',
            neutral: '',
        },
        variant: {
            solid: 'shadow-xs focus:ring-4',
            link: 'focus:ring-2 focus:ring-primary-300',
            ghost: 'focus:ring-2',
            outline: 'border shadow-xs focus:ring-4',
        },
        size: {
            xs: {
                base: 'text-xs px-2.5 h-7',
                label: 'gap-1',
                icon: 'size-3.5',
                spinnerIcon: 'size-3.5',
            },
            sm: {
                base: 'text-xs px-3 h-8',
                label: 'gap-1',
                icon: 'size-4',
                spinnerIcon: 'size-4',
            },
            md: {
                base: 'text-sm px-4 h-10',
                label: 'gap-0.5',
                icon: 'size-5',
                spinnerIcon: 'size-5',
            },
            lg: {
                base: 'text-base px-5 h-12',
                label: 'gap-2',
                icon: 'size-6',
                spinnerIcon: 'size-6',
            },
        },
        iconPos: {
            left: '',
            right: {
                label: 'flex-row-reverse',
            },
        },
        square: {
            true: {
                base: 'justify-center',
                label: 'justify-center -m-px',
            },
        },
        block: {
            true: {
                base: 'w-full justify-center',
                label: 'justify-center',
            },
        },
        loading: {
            true: {
                label: 'opacity-0',
            },
        },
        disabled: {
            true: {
                base: 'cursor-not-allowed',
            },
        },
    },
    compoundVariants: [
        {
            color: 'primary',
            variant: 'solid',
            class: {
                base: 'bg-primary-500 text-white hover:bg-primary-600 disabled:bg-primary-400 focus:ring-primary/50',
            },
        },
        {
            color: 'danger',
            variant: 'solid',
            class: {
                base: 'bg-red-600 text-white hover:bg-red-700 disabled:bg-red-400 focus:ring-red-400/50',
            },
        },
        {
            color: 'neutral',
            variant: 'solid',
            class: {
                base: 'border bg-white text-black border-gray-300 hover:bg-gray-100 hover:border-gray-400 disabled:text-black-100 disabled:border-gray-300 disabled:bg-white focus:ring-gray-400/50',
            },
        },
        {
            color: 'warning',
            variant: 'solid',
            class: {
                base: 'bg-yellow-500 text-yellow-950 hover:bg-yellow-600 disabled:bg-yellow-300 disabled:text-yellow-800 focus:ring-yellow-300/50',
            },
        },
        {
            color: 'warning',
            variant: 'link',
            class: {
                base: 'text-yellow-700 hover:text-yellow-800 disabled:text-yellow-300',
            },
        },
        {
            color: 'warning',
            variant: 'ghost',
            class: {
                base: 'text-yellow-700 hover:bg-yellow-50 disabled:text-yellow-300 focus:ring-yellow-300',
            },
        },
        {
            color: 'warning',
            variant: 'outline',
            class: {
                base: 'border-yellow-500 text-yellow-700 hover:bg-yellow-500 hover:text-yellow-950 disabled:border-yellow-300 disabled:text-yellow-300 disabled:bg-transparent focus:ring-yellow-300/50',
            },
        },
        {
            color: 'success',
            variant: 'solid',
            class: {
                base: 'bg-green-600 text-white hover:bg-green-700 disabled:bg-green-300 focus:ring-green-300/50',
            },
        },
        {
            color: 'success',
            variant: 'link',
            class: {
                base: 'text-green-600 hover:text-green-700 disabled:text-green-300',
            },
        },
        {
            color: 'success',
            variant: 'ghost',
            class: {
                base: 'text-green-600 hover:bg-green-50 disabled:text-green-300 focus:ring-green-300',
            },
        },
        {
            color: 'success',
            variant: 'outline',
            class: {
                base: 'border-green-600 text-green-600 hover:bg-green-600 hover:text-white disabled:border-green-300 disabled:text-green-300 disabled:bg-transparent focus:ring-green-300/50',
            },
        },
        {
            color: 'primary',
            variant: 'link',
            class: {
                base: 'text-primary hover:text-primary-700 hover:underline hover:underline-offset-3 disabled:text-primary-300',
            },
        },
        {
            color: 'danger',
            variant: 'link',
            class: {
                base: 'text-red-600 hover:text-red-700 disabled:text-red-300',
            },
        },
        {
            color: 'neutral',
            variant: 'link',
            class: {
                base: 'text-black-700 hover:text-primary disabled:text-gray-300',
            },
        },
        {
            color: 'primary',
            variant: 'ghost',
            class: {
                base: 'text-primary hover:bg-primary-50 disabled:text-primary-300 focus:ring-primary-300',
            },
        },
        {
            color: 'danger',
            variant: 'ghost',
            class: {
                base: 'text-red-600 hover:bg-red-50 disabled:text-red-300 focus:ring-red-300',
            },
        },
        {
            color: 'neutral',
            variant: 'ghost',
            class: {
                base: 'text-black-700 hover:bg-gray-100 disabled:text-gray-300 focus:ring-gray-300',
            },
        },
        {
            color: 'primary',
            variant: 'outline',
            class: {
                base: 'border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white disabled:border-primary-300 disabled:text-primary-300 disabled:bg-transparent focus:ring-primary/50',
            },
        },
        {
            color: 'danger',
            variant: 'outline',
            class: {
                base: 'border-danger text-danger hover:bg-danger hover:text-white disabled:border-red-300 disabled:text-red-300 disabled:bg-transparent focus:ring-red-400/50',
            },
        },
        {
            color: 'neutral',
            variant: 'outline',
            class: {
                base: 'border-gray-300 text-black-700 hover:bg-gray-100 hover:border-gray-400 disabled:border-gray-200 disabled:text-gray-300 disabled:bg-transparent focus:ring-gray-400/50',
            },
        },
        {
            size: 'sm',
            square: true,
            class: 'size-8 p-0',
        },
        {
            size: 'sm',
            square: false,
            iconPos: 'left',
            class: {
                icon: '-translate-x-1',
            },
        },
        {
            size: 'sm',
            square: false,
            iconPos: 'right',
            class: {
                icon: 'translate-x-1',
            },
        },
        {
            size: 'md',
            square: true,
            class: 'size-10 p-0',
        },
        {
            size: 'md',
            square: false,
            iconPos: 'left',
            class: {
                icon: '-translate-x-1.5',
            },
        },
        {
            size: 'md',
            square: false,
            iconPos: 'right',
            class: {
                icon: 'translate-x-1.5',
            },
        },
        {
            size: 'lg',
            square: true,
            class: 'size-12 p-0',
        },
        {
            size: 'lg',
            square: false,
            iconPos: 'left',
            class: {
                icon: '-translate-x-2',
            },
        },
        {
            size: 'lg',
            square: false,
            iconPos: 'right',
            class: {
                icon: 'translate-x-2',
            },
        },
    ],
    defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
    },
});
